import { createContext } from 'react'

import { FormLayoutContextValue } from '../interface'

export const FormLayoutContext = createContext<FormLayoutContextValue>({})
